import UseCouponDialogue from './UseCouponDialogue'

export default UseCouponDialogue
